export const isMacOs = () => navigator.userAgent.includes('Mac OS X')

export const commandKey = isMacOs() ? '⌘' : 'Ctrl'
export const commandKeyName = isMacOs() ? 'Cmd' : 'Ctrl'

export const optionKey = isMacOs() ? '⌥' : 'Alt'
export const optionKeyName = 'Alt'
